import App from './App';
import SplashScreen from './components/SplashScreen';
import { useSplashGate } from './hooks/useSplashGate';

export default function Root() {
  const splashVisible = useSplashGate();
  return (
    <>
      <SplashScreen visible={splashVisible} />
      <App />
    </>
  );
}
